import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as SlashIcon } from './slash.svg';

export const Slash = IconHOC(SlashIcon);
